import React, { createContext, useContext } from "react";
import { useBillingStatus, UseBillingStatusResult } from "../hooks/useBillingStatus";

const BillingContext = createContext<UseBillingStatusResult | null>(null);

export function BillingProvider({ children }: { children: React.ReactNode }) {
  const value = useBillingStatus();
  return <BillingContext.Provider value={value}>{children}</BillingContext.Provider>;
}

export function useBillingContext(): UseBillingStatusResult {
  const ctx = useContext(BillingContext);
  if (!ctx) {
    throw new Error("useBillingContext must be used within BillingProvider");
  }
  return ctx;
}
